import { render, staticRenderFns } from "./TagsBox.vue?vue&type=template&id=564df3d2&scoped=true&"
import script from "./TagsBox.vue?vue&type=script&lang=js&"
export * from "./TagsBox.vue?vue&type=script&lang=js&"
import style0 from "./TagsBox.vue?vue&type=style&index=0&id=564df3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564df3d2",
  null
  
)

export default component.exports